<template>
  <div>
    <template v-if="!loading">
      <!-- <b style="color:red">{{informText}}</b> -->
      <v-col cols="12">
        <v-alert type="error" v-if="informText != ''">
          {{ informText }}
        </v-alert>
        <v-row>
          <v-col cols="12">
            <v-select
              :items="listSites"
              :item-text="(obj) => obj.showName"
              :item-value="(obj) => obj"
              dense
              multiple
              v-model="site"
              label="Import To Site"
            ></v-select>
          </v-col>
          <!--
          <v-col cols="6" class="border">
            <v-row>
              <v-col cols="6">
                <v-radio-group
                  v-model="upload_to_store"
                  :mandatory="false"
                  class="small ma-0"
                  label="Upload to store"
                >
                  <v-radio label="Yes" value="true"></v-radio>
                  <v-radio label="No" value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="6">
                <v-radio-group
                  v-model="operation_type"
                  :mandatory="false"
                  class="small ma-0"
                  label="Operation Type"
                >
                  <v-radio label="Create New" value="create"></v-radio>
                  <v-radio label="Update Existing" value="update"></v-radio>
                </v-radio-group>
                <v-select
                  dense
                  outlined
                  :items="productProperties"
                  label="Product Properties"
                  v-if="operation_type == 'update'"
                  multiple
                  v-model="modified_fields"
                ></v-select>
              </v-col>
            </v-row>
          </v-col> -->

          <v-col cols="12" class="border">
            <v-row>
              <v-col cols="12" style="text-align: left">
                <div><b>Product Group: </b> {{ selectedItem.group_name }}</div>
                <div>
                  <b>{{ selectedItemText }}: </b>
                  {{ selectedItem.product_codes.join(", ") }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-col cols="12">
          <v-btn color="success" @click="exportData" v-if="site != ''">
            Export Data
          </v-btn>
          <v-btn color="success" @click="exportData" v-else disabled>
            Export Data
          </v-btn>
          <!-- <button class="btn btn-success" @click="check">Check</button> -->
          &nbsp;

          <v-btn class="white--text" color="warning" @click="cancelData">
            Cancel <v-icon right dark>mdi-window-close</v-icon>
          </v-btn>
        </v-col>
      </v-col>
    </template>
    <template v-else>
      <img v-bind:src="require('../../assets/loading/loading.gif')" />
    </template>
  </div>
</template>

<script>
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "ExportProductGroup",
  props: {
    selectedItem: Object,
    username: String,
  },
  data: () => ({
    loading: false,
    AuthStr: "",
    listSites: [],
    site: [],
    selected: "",
    informText: "",
    radios: "radio-1",
    selectedItemText: "",
    listTagsName: [],
    upload_to_store: "",
    operation_type: "",
    filterShow: false,
    modified_fields: ["tags"],
    listProductKind: {
      CRL: [],
      PSL: [],
    },
  }),
  methods: {
    async loadData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "product-group-export-loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        axios
          .get(window.domain + "sites", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("response: ", response);
            if (response.data.error_message == "") {
              this.listSites = response.data.data;
              for (var a of this.listSites) {
                if (a.brand_name) {
                  a["showName"] = a.code + " - " + a.brand_name;
                } else {
                  a["showName"] = a.code;
                }
              }
            } else {
              this.informText = response.data.error_message;
            }

            this.loading = false;
          })
          .catch((error) => {
            console.log("error ", error);
          });
      } else {
        console.log(
          "currentSession product-group-loadData-undefined: ",
          currentSession
        );
      }
    },

    async exportData() {
      this.loading = true;
      this.informText = "";

      var currentSession = await this.$root.$refs.App.currentSession(
        "crawl-product-export-exportData"
      );

      //console.log('currentSession: ',currentSession.accessToken)

      console.log("site: ", this.site);
      var siteSelected = [];
      for (const s of this.site) {
        siteSelected.push(s.code);
      }

      for (var b of this.selectedItem.product_codes) {
        if (b.indexOf("CRL") > -1) {
          this.listProductKind.CRL.push(b);
        } else if (b.indexOf("PSL") > -1) {
          this.listProductKind.PSL.push(b);
        }
      }

      console.log("listProductKind: ", this.listProductKind);
      if (this.listProductKind.CRL.length > 0) {
        var temp = [];

        for (var c of this.listProductKind.CRL) {
          console.log("c: ", c);
          temp.push(c.slice(3));
        }

        var item = {
          import_to_sites: siteSelected,
          upload_to_store: true,
          operation_type: "update",
          product_prefix: "CRL",
          export: this.selectedItem.product_codes.length,
          product_ids: temp,
          exported_user_username: this.username,
          filters: {
            product_type_id: "",
            search_by: "",
            search_word: "",
            status: "",
            tags: "",
            created_from: "",
            created_to: "",
          },
          modified_fields: this.modified_fields,
        };

        console.log("item: ", JSON.stringify(item));
        //SEND API
        if (currentSession.accessToken) {
          await fetch(window.domain + "products/export-products", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(item),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("exportData: ", data);
              console.log("data.message: ", data.message);
              //var error = data.error_message.toString()
              if (data.error_message == "") {
                console.log("OK");
              } else if (data.message == "Service Unavailable") {
                console.log("OK");
              } else {
                this.loading = false;
                this.informText = data.error_message;
                return;
              }
            })
            .catch((error) => {
              console.log("Error:", error);
            });
        } else {
          console.log(
            "currentSession crawl-product-export-exportData-undefined",
            currentSession
          );
        }
      }

      if (this.listProductKind.PSL.length > 0) {
        var temp2 = [];

        for (var d of this.listProductKind.PSL) {
          console.log("d: ", d.slice(3));
          temp2.push(d.slice(3));
        }
        var item2 = {
          import_to_sites: siteSelected,
          upload_to_store: true,
          operation_type: "update",
          product_prefix: "PSL",
          export: this.selectedItem.product_codes.length,
          product_ids: temp2,
          exported_user_username: this.username,
          filters: {
            product_type_id: "",
            search_by: "",
            search_word: "",
            status: "",
            tags: "",
            created_from: "",
            created_to: "",
          },
          modified_fields: this.modified_fields,
        };

        console.log("item: ", JSON.stringify(item2));
        //SEND API
        if (currentSession.accessToken) {
          await fetch(window.domain + "products/export-products", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(item2),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("exportData: ", data);
              console.log("data.message: ", data.message);
              //var error = data.error_message.toString()
              if (data.error_message == "") {
                console.log("OK");
              } else if (data.message == "Service Unavailable") {
                console.log("OK");
              } else {
                this.loading = false;
                this.informText = data.error_message;
                return;
              }
            })
            .catch((error) => {
              console.log("Error:", error);
            });
        } else {
          console.log(
            "currentSession crawl-product-export-exportData-undefined",
            currentSession
          );
        }
      }

      if (this.informText == "") {
        this.cancelData();
      }
    },

    check() {
      console.log("productProperties: ", this.productProperties);
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },

    cancelData() {
      this.$root.$refs.productGroup.turnOffDialog();
    },
  },

  async mounted() {
    console.log("selectedItem: ", this.selectedItem);

    this.selectedItemText =
      "Selected " + this.selectedItem.product_codes.length + " Item(s)";

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      //let username = currentUser.username;

      var currentSession;
      try {
        currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
        console.log("export-product-mounted currentSession: ", currentSession);
      } catch (error) {
        console.log("export-product-mounted error: ", error);
      }

      if (currentSession != undefined) {
        //this.userId = currentSession.accessToken.payload.username;
        //currentSession.accessToken.jwtToken;
        let accessToken = currentSession.accessToken.jwtToken;
        console.log("accessToken-crawl-product-mounted: ", accessToken);
        //userLoggedIn = true;
        await this.loadData();
      }
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
</style>